<template>
  <div id="dashboard-teamlist">
    <div class="row" id="team-actions">
      <b-col md=5>
        <h1>{{ team.name || 'Team' }}</h1>
      </b-col>
      <b-col md=7 class="pb-md-0 pb-5" style="height: 1em;">
        <MessageFormGroup v-if="showInviteAdmin || showInviteUser">
          <b-input-group>
            <b-form-input size="sm" v-model="inviteEmail" id="invite-email" placeholder="Email" />
            <div class="input-group-append">
              <b-button-group>
                <b-btn v-if="!showInviteAdmin" size="sm" @click="onClickInviteUser" id="invite-button" variant="default"><i class="fa fa-envelope"/> Invite</b-btn>
                <b-dropdown v-else size="sm" @click="onClickInviteUser" id="invite-button" variant="default" right split>
                  <span slot="button-content"><i class="fa fa-envelope"/> Invite to Order</span>
                  <b-dropdown-item @click="onClickInviteUser" >Invite to order</b-dropdown-item>
                  <b-dropdown-item @click="onClickInviteAdmin" >Invite admin</b-dropdown-item>
                </b-dropdown>
              </b-button-group>
            </div>
          </b-input-group>
        </MessageFormGroup>
      </b-col>
    </div>

    <MessageAlert>
      <div class="button-holder text-right">
        <button class="btn btn-clear pr-0" @click="panel = panel === 'sharing' ? null : 'sharing'">
          <span :class="{active: panel === 'sharing'}">
            <i class="fa fa-link"></i> Share using link
          </span>
        </button>
        <button v-if="flags.enableTeamMembersImport" class="btn btn-clear" @click="panel = panel === 'importing' ? null : 'importing'">
          <span :class="{active: panel === 'importing'}">
            <i class="fa fa-download"></i> Import team members
          </span>
        </button>
      </div>
      <TeamMembersImport v-if="panel === 'importing'" @cancel="panel = null"/>
      <TeamSharePanel v-if="panel === 'sharing'" @cancel="panel = null"/>

      <WaveSpinner v-if="isTeamBusy"/>
      <table class="table" v-else>
        <thead>
          <tr>
            <th>Team Member</th>
            <th>Date Joined</th>
            <th>Role</th>
            <th v-if="flags.showLastOrderDate">Last order date</th>
          </tr>
        </thead>
        <tbody :class="{hover: isAdmin}">
          <MemberRow :member="member" v-for="member in members" :key="member.username" />
        </tbody>
      </table>
    </MessageAlert>

    <b-alert variant="success" id="alert" show>
    <b>Welcome to the Team page.</b> Add team members to allow them to self-order or
    to make admin-ordering easier by saving their imprint information.
    </b-alert>

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import wrapAction from "@/lib/bubble/wrapAction";
import MemberRow from "./MemberRow";
import TeamMembersImport from './TeamMembersImport.vue';
import TeamSharePanel from './TeamSharePanel.vue';

export default {
  components: {MemberRow, TeamMembersImport, TeamSharePanel},
  data() {
    return {
      inviteEmail: '',
      panel: null,
    }
  },
  computed: {
    ...mapGetters(["members", "flags", "user", "isAdmin", "isTeamBusy", "team"]),
    showInviteAdmin() {
      return this.isAdmin;
    },
    showInviteUser() {
      // We may decide to limit this to Admins in future.
      return true;
    },
  },
  mounted() {
    this.loadTeamMembers();
  },
  methods: {
    ...mapActions(["loadTeamMembers", "reloadTeamMembers"]),
    inviteMember: wrapAction({
      action: "inviteMember",
      arg: {data: "inviteEmail"},
      success: "Message has been sent!"
    }),
    inviteAdmin: wrapAction({
      action: "inviteAdmin",
      arg: {data: "inviteEmail"},
      success: "Message has been sent!"
    }),
    async onClickInviteUser(event) {
      await this.inviteMember(event);
      this.reloadTeamMembers();
    },
    async onClickInviteAdmin(event) {
      await this.inviteAdmin(event);
      this.reloadTeamMembers();
    }
  },
};
</script>

<style scoped lang="scss">
  @import '~scss/colors';

  tbody.hover:hover {
    background-color: $frost-1;
  }
  #team-actions {
    margin-bottom: 2em;
  }

  #alert {
    border-radius: 2px;
  }

  h1 {
    margin-top: 0;
    font-size: 2em;
  }

  #dashboard-design {
    min-height: calc(100vh - 244px);
  }

  .btn span.active {
    border-bottom: 3px solid $red;
  }
  .btn.btn-clear {
    background: inherit;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/team/TeamMemberList.vue